import React from 'react';

interface IRequestGuarateeIcon {
  fillColor: string;
  height?: string;
  width?: string;
}

const RequestGuarateeIcon = ({ fillColor, height, width }: IRequestGuarateeIcon) => {
  return (
    <svg
      width={width || '21'}
      height={height || '20'}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.05837 1.66602H14.2834C17.1084 1.66602 19 3.64935 19 6.59935V13.4085C19 16.3493 17.1084 18.3327 14.2834 18.3327H7.05837C4.23337 18.3327 2.33337 16.3493 2.33337 13.4085V6.59935C2.33337 3.64935 4.23337 1.66602 7.05837 1.66602ZM10.1917 12.491L14.15 8.53268C14.4334 8.24935 14.4334 7.79102 14.15 7.49935C13.8667 7.21602 13.4 7.21602 13.1167 7.49935L9.67504 10.941L8.21671 9.48268C7.93337 9.19935 7.46671 9.19935 7.18337 9.48268C6.90004 9.76602 6.90004 10.2243 7.18337 10.516L9.16671 12.491C9.30837 12.6327 9.49171 12.6993 9.67504 12.6993C9.86671 12.6993 10.05 12.6327 10.1917 12.491Z"
        fill={fillColor || '#12B76A'}
      />
    </svg>
  );
};

export default RequestGuarateeIcon;
